import React from 'react'
import avatarImg from '../../images/practice/4.jpg'

import './style.scss'

const contentByCategory = {
    'Estate Planning': {
        description: 'Estate planning is making sure you have a plan in place in the event of your death or incapacity to protect your legacy. A comprehensive estate plan ensures your assets are distributed according to your wishes, protects minor children by naming trusted guardians, minimizes tax burdens, and avoids the time, expense and public nature of probate court. We offer an approach to creating an estate plan that is hassle-free and tailored to your needs.',
        goalsTitle: 'We help you understand your goals.',
        goalsDescription: 'We sit down with you and discuss your specific priorities and needs. This may include:',
        listItems: [
            'Personalized will creation to ensure your wishes are legally documented',
            'Setting up a living trust',
            'Guardianship arrangements for minor children and ensuring that your assets are managed responsibly until your children come of age',
            'Special needs trust planning for disabled family members',
            'Modifying existing wills and trusts after a major life event change',
            'Strategic trust structures to minimize estate taxes',
            'Achieving charitable goals',
            'Real estate transfer planning',
            'Business succession planning to safeguard the continued operations of your business when you are no longer running it',
        ]
    },

    'Estate & Trust Administration': {
        description: 'We represent and advise trustees, estate executors and administrators in trust and estate administration and probate matters. We also represent beneficiaries if there are any questions about, or disputes regarding, the actions of the Trustee.',
        goalsTitle: 'We are here to support.',
        goalsDescription: 'Should you find yourself named a trustee, we provide clarity on the complex nature of trust administration:',
        listItems: [
            'Inventorying trust assets and ensuring assets are held by the appropriate custodian',
            'Managing assets while adhering to the trust’s long-term objectives',
            'Complying with trust terms and conditions',
            'Ensuring tax compliance',
            'Clarifying beneficiary rights and trustee responsibilities, helping avoid potential disputes among heirs or beneficiaries',
        ]
    },

    'Elder Care Planning': {
        description: 'Preparing for our care and support as we age, or our loved ones age, can be challenging. Having the right plan and paperwork in place so that crucial medical and financial decisions can be made on your behalf is important to do before a crisis takes place. We help come up with a comprehensive plan for the financial security, healthcare needs and personal autonomy needed for later in life.',
        goalsTitle: 'We help make sure you have a plan in place as you age.',
        goalsDescription: 'We help collaborate with others to ensure comprehensive support and the right paperwork and plan is in place to:',
        listItems: [
            'Allow your designated agent to make crucial medical decisions on your behalf without having to go through a lengthy court process to gain decision-making authority',
            'Enable your designated agent to handle your financial affairs such as paying bills, paying taxes and managing investments',
            'Provide family harmony by clearly laying out who should make decisions on your behalf',
            'Help qualify for Medi-Cal long-term benefits while preserving some assets for spouses and heirs'
            ,
        ]
    },

    'Estate Planning for Young Adults': {
        description: 'Once your child becomes a legal adult (age 18), estate planning is necessary to ensure that parents are still able to act on behalf of their adult children for medical, financial, and legal purposes.',
        goalsTitle: 'We help support your young adult children by having the right documents in order.',
        goalsDescription: 'These documents help protect your young adult\'s interests:',
        listItems: [
            'Durable Power of Attorney',
            'Advance Health Care Directive so your adult child’s health wishes are carried out in the event of incapacitation',
            'HIPAA consent forms allowing a healthcare provider to share their adult child’s protected health information',
            'Simple will',
            'Generic FERPA Consent Form (for college students) that authorizes parents to communicate with a college regarding the student’s classes, transcripts, grades, and more',
        ]
    }
};

const listItem = [
    'Personalized will creation to ensure your wishes are legally documented',
    'Guardianship arrangements for minor children and ensuring that your assets are managed responsibly until your children come of age',
    'Special needs trust planning for disabled family members',
    'Achieving charitable goals',
    'Modifying existing wills and trusts after a major life event change',
    'Strategic trust structures to minimize estate taxes',
    'Real estate transfer planning',
    'Business succession planning to safeguard the continued operations of your business when you are no longer running it',
    'Setting up a living trust'
]
const SingleContentArea = ({ className, avatar, image, selectedCategory }) => {
    const content = contentByCategory[selectedCategory] || {};

    return (
        <div className={className}>
            <div className="singleContentWrap">
                <h3>{selectedCategory}</h3>
                <p>{content.description}</p>
                <h4>{content.goalsTitle}</h4>
                <p>{content.goalsDescription}</p>
                {avatar && content.listItems && (
                    <div className="avatarWra">
                        <div className="row">
                            <div className="col-md-12">
                                <ul>
                                    {content.listItems.map(item => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SingleContentArea